import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchPaginatedPostageAccounts } from '../services/api';
import PaginationComponent from '../components/PaginationComponent';
import AccountTable from '../components/AccountTable';

function PaginatedPostageAccountList() {
    const { pageNumber } = useParams();
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState([]);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(pageNumber ? parseInt(pageNumber) : 1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        fetchPaginatedPostageAccounts(currentPage, 20)
            .then(data => {
                setAccounts(data.accounts);
                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('Failed to fetch accounts:', error);
                setError('Failed to fetch accounts');
                setIsLoading(false);
            });
    }, [currentPage]);

    useEffect(() => {
        if (pageNumber) {
            setCurrentPage(parseInt(pageNumber));
        }
    }, [pageNumber]);

    const handlePageChange = (pageNumber) => {
        navigate(`/postage-accounts/${pageNumber}`);
    };

    if (isLoading) {
        return <div className="container mt-3"><h1>Loading...</h1></div>;
    }

    

    return (
        <div className="container mt-3">
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <div className="page-header">
                <h1 className="gradient-under">Postage Accounts</h1>
            </div>
            <p>All Postage Accounts are listed here. Click an account to view it's details, join the account, or manage your existing accounts. If you're looking for a specific account try the <a href="/search-postage-accounts">Search Page</a>.</p>
            <hr />
            <AccountTable accounts={accounts} />
            <PaginationComponent currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    );
}

export default PaginatedPostageAccountList;
